import {propColor} from 'utils/Helper';

export default theme => ({
  root: {
    fontSize: 14,
    marginLeft: 12,
    top: 3,
    position: 'relative',
    color: propColor('color', '#888'),
  },
  button: {
    border: '1px solid #ccc',
    background: '#eaeaea',
    fontSize: 12,
    dispaly: props => (props.block === true) ? 'block' : 'initial',
    width: props => (props.block === true) ? '100%' : 'auto',
    padding: '10px 5px',
    marginTop: 12,
    borderRadius: 3,
    cursor: 'pointer'
  }
});

